module.exports = __webpack_public_path__ + "img/head_six.80c79773.png";